import { render, staticRenderFns } from "./ExtraNumberSettings.vue?vue&type=template&id=1aff7134&scoped=true"
import script from "./ExtraNumberSettings.vue?vue&type=script&lang=ts"
export * from "./ExtraNumberSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff7134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aff7134')) {
      api.createRecord('1aff7134', component.options)
    } else {
      api.reload('1aff7134', component.options)
    }
    module.hot.accept("./ExtraNumberSettings.vue?vue&type=template&id=1aff7134&scoped=true", function () {
      api.rerender('1aff7134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraNumberSettings.vue"
export default component.exports